import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Dashboard(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M0 13.333h10.667V0H0v13.333ZM0 24h10.667v-8H0v8Zm13.333 0H24V10.667H13.333V24Zm0-24v8H24V0H13.333Z" />
    </IconWrapper>
  );
}
